import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AppointmentControllerApi } from "../../services";
import { getConfigObject, getXtenantId, useBaseData } from "../../utils/utils";

interface UseAppointmentDashboardStatsProps {
  startDate?: string;
  endDate?: string;
  providerUuid?: Array<string>;
  locationUuid?: Array<string>;
  providerGroupId?: string | null;
  statuses?: string[];
  modes?: string[];
  scheduledSources?: string[];
}

/**
 * @description Hook for fetching appointment dashboard KPI stats
 */
export function useAppointmentDashboardStats({
  startDate,
  endDate,
  providerUuid,
  locationUuid,
  providerGroupId,
  statuses,
  modes,
  scheduledSources,
}: UseAppointmentDashboardStatsProps): useBaseData<any> {
  return useQuery({
    queryKey: [
      "appointment-dashboard-stats",
      startDate,
      endDate,
      providerUuid,
      locationUuid,
      statuses,
      modes,
      scheduledSources,
    ],
    enabled: !!providerGroupId,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new AppointmentControllerApi(getConfigObject())
        .getAppointmentDashboardStats(
          startDate,
          endDate,
          providerUuid,
          statuses,
          modes,
          scheduledSources,
          locationUuid,
          providerGroupId ?? getXtenantId()
        )
        .then((res) => res?.data),
  });
}
